// Dok 18 – Projektörens arbetsmiljörutin som Word-dokument.
import type { Paragraph, Table } from "docx";
import { downloadWordDocument } from "@/lib/documentGenerator/exportHistory";
import { createStampForCurrentUser } from "@/lib/documentGenerator/watermark";
import { body, buildDocument, h1 } from "@/lib/documentGenerator/docTheme";
import {
  DESIGNER_ROUTINE_SECTIONS,
  DESIGNER_ROUTINE_STATUS_LABELS,
} from "@/lib/basProcess/designerRoutine";
import { documentFooter } from "@/lib/documentGenerator/documentFooter";

export interface DesignerRoutineDoc {
  name: string;
  version: string;
  status: string;
  sections: Record<string, string>;
}

export const generateDesignerRoutineWordDocument = async (
  routine: DesignerRoutineDoc,
  projectName?: string
) => {
  const documentName = routine.name || "Projektörens arbetsmiljörutin";
  const stamp = await createStampForCurrentUser({
    docNumber: "18",
    documentName,
    projectName,
  });

  const children: (Paragraph | Table)[] = DESIGNER_ROUTINE_SECTIONS.flatMap((s) => [
    h1(s.title),
    body(routine.sections?.[s.key] ?? ""),
  ]);

  const footer = await documentFooter({
    docNumber: "18",
    documentType: "projektorrutin",
    signatureRoles: ["Projektör", "Uppdragsledare"],
  });

  const doc = buildDocument({
    meta: {
      review: footer.review,
      docNumber: "18",
      documentName,
      projectName,
      version: routine.version || "1.0",
      status:
        DESIGNER_ROUTINE_STATUS_LABELS[
          routine.status as keyof typeof DESIGNER_ROUTINE_STATUS_LABELS
        ] || routine.status,
    },
    stamp,
    children: [...children, ...footer.children],
  });

  await downloadWordDocument(
    doc,
    `Dok18_Projektorsrutin_${(projectName || "projekt").replace(/[^\w-]+/g, "_")}.docx`,
    {
      documentType: "projektorrutin",
      docNumber: "18",
      documentName,
      snapshot: routine,
      stamp,
    }
  );
};

export default generateDesignerRoutineWordDocument;
